var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2031 35.9998C18.8035 35.9677 18.6787 35.7184 18.6237 35.3654C18.4663 34.3576 18.3014 33.3499 18.1083 32.3494C17.3759 28.5575 14.7318 26.0708 10.8384 25.4845C9.93528 25.3489 9.03509 25.1885 8.13044 25.0514C7.77839 24.9989 7.49466 24.8764 7.47535 24.487C7.45456 24.0626 7.72788 23.9051 8.12301 23.8453C9.14947 23.6892 10.1759 23.5332 11.1949 23.3392C15.0735 22.6012 17.5824 20.03 18.184 16.2002C18.3237 15.3134 18.4841 14.4282 18.6237 13.5414C18.6831 13.1622 18.8376 12.8793 19.2744 12.8997C19.6621 12.9187 19.7987 13.1754 19.8522 13.5341C19.98 14.399 20.1523 15.2565 20.2815 16.1214C20.8876 20.1671 23.6476 22.855 27.7846 23.4311C28.6402 23.5507 29.4914 23.714 30.3455 23.8467C30.7287 23.9065 31.0184 24.0465 30.9991 24.4841C30.9813 24.8764 30.7124 24.9974 30.3559 25.0514C29.3547 25.2031 28.352 25.3577 27.3567 25.5414C23.4129 26.2677 20.8697 28.8769 20.286 32.7694C20.1567 33.6328 19.9918 34.4918 19.8537 35.3552C19.7928 35.7315 19.6472 36.0042 19.2045 35.9998H19.2031Z",
    fill: "url(#paint0_linear_113_1313)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7184 12.7555C14.7021 13.0385 14.4822 13.0603 14.2534 13.0968C13.4736 13.2222 12.6952 13.3535 11.9168 13.4949C9.95006 13.8523 8.48094 15.2611 8.09175 17.1833C7.92835 17.9913 7.80357 18.8066 7.66988 19.6204C7.64017 19.7998 7.60007 19.9791 7.39953 19.9996C7.14997 20.0229 7.07867 19.8318 7.04153 19.6247C6.90636 18.8357 6.77267 18.0467 6.62412 17.2606C6.26018 15.3297 4.82968 13.8946 2.86591 13.5081C2.04296 13.3462 1.21259 13.2237 0.383703 13.0939C0.199506 13.0647 0.0212506 13.0253 0.00193962 12.827C-0.0218277 12.5805 0.169797 12.5149 0.383703 12.4799C1.16357 12.3515 1.94195 12.2203 2.71885 12.0817C4.78363 11.7142 6.22007 10.3331 6.6256 8.30876C6.77861 7.54746 6.89447 6.78033 7.02519 6.01465C7.05787 5.82505 7.05639 5.5917 7.31189 5.56983C7.61938 5.54503 7.6372 5.79442 7.67434 6.01465C7.80655 6.77887 7.94024 7.54454 8.08284 8.3073C8.43935 10.2324 9.88322 11.6807 11.8425 12.0584C12.6417 12.213 13.4483 12.3326 14.252 12.4624C14.4495 12.4945 14.6515 12.5032 14.7169 12.7555H14.7184Z",
    fill: "url(#paint1_linear_113_1313)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2455 0C16.7193 1.08216 16.501 2.21828 17.3432 3.00875C18.1617 3.7788 19.2684 3.61983 20.4003 4.01069C19.2892 4.47447 18.1335 4.26008 17.3269 5.07535C16.5247 5.88478 16.6822 6.96839 16.3108 8.05055C15.7909 7.03402 16.0434 5.89207 15.2309 5.09139C14.408 4.2805 13.2671 4.48031 12.1872 4.03694C13.2701 3.59649 14.4243 3.80068 15.2324 2.97083C16.0108 2.17015 15.8414 1.08362 16.2455 0.00145843V0Z",
    fill: "url(#paint2_linear_113_1313)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_113_1313",
    x1: 8.59529,
    y1: 29.4442,
    x2: 30.7888,
    y2: 29.4442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172596,
    stopColor: "#1C36BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C75BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_113_1313",
    x1: 0.701301,
    y1: 15.9055,
    x2: 14.5862,
    y2: 15.9055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172596,
    stopColor: "#1C36BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C75BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_113_1313",
    x1: 12.5786,
    y1: 5.76594,
    x2: 20.3266,
    y2: 5.76594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.172596,
    stopColor: "#1C36BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C75BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group 1.01d5bb33e96fa5294edf101b572825c9.svg";
export { ForwardRef as ReactComponent };